import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { QuickQuoteLife,ErrQuotesLife,PostQuoteLife } from "../../Redux/actions/NumLife";
import { 
  Button, 
  Form,
  Radio,
  message
} from 'antd/lib';

export default function LifeInsurerFilter({setisModalInsurer}) {
    const dispatch = useDispatch();
    const Healthnum = useSelector((state) => state?.healthdetail?.healthnum);
  const QuotePost = useSelector((state) => state?.lifedetail?.QuickQuotePost);
    const QuickQuotes = useSelector((state) => state?.lifedetail?.quickquotes);
    console.log("QuickQuotes",QuickQuotes)
    const QuickQuotePost = useSelector((state) => state?.lifedetail?.quickQuotePost);
    const QuoteInput = useSelector((state) => state?.cardetail?.quoteInput);
    console.log(QuickQuotePost)
    const [loading, setLoading] = useState(false)


    const onChange = (e) => {
      console.log('radio checked', e.target.value);
      // setValue(e.target.value);
    };
    const onFinish = (values) => {
      console.log('product values',values)
      setisModalInsurer(false)
    }; 
  return (
    <>
       <Form
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        >
            <p className="border-bottom mb-0"
             style={{fontSize: "14px", paddingBottom:"10px"}}>Select the insurer of your choice and view plans offered by the selected insurer.</p>
          <Form.Item
          name="insurerFilter"
        // className="cvEditSec"
          rules={[
            {
              required: true,
              message: 'Please select any one Insurer',
            },
          ]}
          initialValue={QuotePost?.policyPeriod}
          >
            <Radio.Group
              className="py-3 px-3 pb-0 bg-white ant-radio-layout filt-prod-sec-health"
              onChange={onChange}
              >
                {QuickQuotes?.map((item, index) => (
                    <Radio key={index} value={item?.insurer}>
                    <div className="insu-pro-filter">
                        <img src={item?.logo} alt={item?.insurer} style={{width: "95px"}}/>
                        <p className="mb-0">{item?.insurer === 'shri_ram' ? 'SHRIRAM' : item?.insurer}</p>
                    </div>
                    </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
            <Form.Item style={{textAlign: "center"}}>
                <Button type="primary" 
                htmlType="submit"
                className="update-qut-button"
                loading={loading}
                >Update</Button>
            </Form.Item>
        </Form>
    </>
  );
}